module.exports = __webpack_public_path__ + "components/AuthorizationModal/connect_with_moka-b02ea47d94345f7bf3c4d31b2b7b8d58.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/AuthorizationModal/connect_with_moka.png
// module id = 366
// module chunks = 0 1